import Model from './utils/model'
import nexus from '@db2b/nexus-js'
import moment from 'moment'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Facture'
    },
    name: 'invoice',
    url: nexus.url('document2', 'invoices')
  },
  getStatus (invoice) {
    if(invoice.type === 'CREDIT') {
      return {
        color: 'success',
        icon: 'fa-check',
        text: 'Remboursé le ' + moment(invoice.created_at).format('L')
      }
    } else if (invoice.loss_at !== null) {
      return {
        color: 'muted',
        icon: 'fa-times',
        text: 'En perte'
      }
    } else if (invoice.paid_at === null) {
      if (invoice.litigation_started_at !== null) {
        return {
          color: 'danger',
          icon: 'fa-times',
          text: 'Recouvrement le ' + moment(invoice.litigation_started_at).format('L')
        }
      } else if (moment(invoice.deadline_at).isSameOrBefore(moment())) {
        return {
          color: 'warning',
          icon: 'fa-exclamation-triangle',
          text: 'Retard de paiement'
        }
      } else {
        return {
          color: 'warning',
          icon: 'fa-exclamation-circle',
          text: 'Non payée'
        }
      }
    } else {
      return {
        color: 'success',
        icon: 'fa-check',
        text: 'Payée le ' + moment(invoice.paid_at).format('L')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/invoice.js